import dayjs from 'dayjs'
import { tagMatch } from './tagUtil'

const imgSrc=(thumb)=>{
  let thumb_ = thumb && (thumb.node ? thumb.node : thumb);
  return thumb_ && thumb_.m ? thumb_.m : thumb_;
}

const onLoad = (e) => {
  if (e.target.srcset) e.target.dataset.load = 'done';
}

const linkMaker=(type, date, databaseId)=> {
  if(!type || !date || !databaseId || type==='tv') return '';
  let link = `/${dayjs(date).format('YYYY/M/D')}/${databaseId}`
  if(type!=='posts') link = `/${type}`+ link;
  return link;
}


const tagFilterAry=(filter, ary)=> {
  return (!ary || !Array.isArray(ary)) ? [] : ary.filter(se=>{
    const matched = se.tags && tagMatch(se.tags, filter);
    return matched && matched.length>0
  });
}

const tagFilter=(filter, items)=> {
  const items_={};
  Object.keys(items).forEach(year=> {
    items_[year] = tagFilterAry(filter, items[year]);
  })
  return items_;
}

const newsFormater=(items)=> {
  let eNN = [];
  let eTN = [];
  items.nodes.forEach(node=> {
    const type = node.newsACF ? (node.newsACF.kpopnewsFlag ? 'kpop' : "") : "";

    let tousen = false;
    let tags = node.tags && node.tags.nodes && node.tags.nodes.length > 0 ? node.tags.nodes.map(res=> {
      if(res.name && res.name.indexOf('当選') !== -1){
        tousen = true;
        return null;
      }else {
        return res.name;
      }
    }).filter(res=>res) : null;

    let thumb = node.featuredImage && node.featuredImage.node && node.featuredImage.node.m;
    if(thumb) thumb = thumb.replace("http:", "https:");
    const item_ = {
      title: node.title, type, tags, tousen,
      date: dayjs(node.date).format("YYYY-MM-DD"),
      databaseId: node.databaseId,
      thumb
    };

    if(tousen){
      eTN.push(item_)
    }else {
      eNN.push(item_);
    }
    //const _ = tousen ? eTN.push(item_) :  eNN.push(item_);
    return item_;
  });

  return {eNN, eTN}
}


export {imgSrc, onLoad, linkMaker, tagFilter, tagFilterAry, newsFormater}
